var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 19,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_705_8637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.5C23.9187 25.5 27.5 22.1406 27.5 18C27.5 13.8594 23.9187 10.5 19.5 10.5C15.0813 10.5 11.5 13.8594 11.5 18C11.5 19.6969 12.1 21.2594 13.1125 22.5156L11.5875 25.4C11.4375 25.6812 11.4844 26.025 11.7 26.2594C11.9156 26.4937 12.2563 26.5656 12.5469 26.4406L16.2469 24.8562C17.2406 25.2688 18.3406 25.5 19.5 25.5ZM15.5 17C15.7652 17 16.0196 17.1054 16.2071 17.2929C16.3946 17.4804 16.5 17.7348 16.5 18C16.5 18.2652 16.3946 18.5196 16.2071 18.7071C16.0196 18.8946 15.7652 19 15.5 19C15.2348 19 14.9804 18.8946 14.7929 18.7071C14.6054 18.5196 14.5 18.2652 14.5 18C14.5 17.7348 14.6054 17.4804 14.7929 17.2929C14.9804 17.1054 15.2348 17 15.5 17ZM19.5 17C19.7652 17 20.0196 17.1054 20.2071 17.2929C20.3946 17.4804 20.5 17.7348 20.5 18C20.5 18.2652 20.3946 18.5196 20.2071 18.7071C20.0196 18.8946 19.7652 19 19.5 19C19.2348 19 18.9804 18.8946 18.7929 18.7071C18.6054 18.5196 18.5 18.2652 18.5 18C18.5 17.7348 18.6054 17.4804 18.7929 17.2929C18.9804 17.1054 19.2348 17 19.5 17ZM22.5 18C22.5 17.7348 22.6054 17.4804 22.7929 17.2929C22.9804 17.1054 23.2348 17 23.5 17C23.7652 17 24.0196 17.1054 24.2071 17.2929C24.3946 17.4804 24.5 17.7348 24.5 18C24.5 18.2652 24.3946 18.5196 24.2071 18.7071C24.0196 18.8946 23.7652 19 23.5 19C23.2348 19 22.9804 18.8946 22.7929 18.7071C22.6054 18.5196 22.5 18.2652 22.5 18Z",
    fill: "#3C5199"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_8637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11.5 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentDots);
export default __webpack_public_path__ + "static/media/comment-dots.567554f96cf99cd52c126623b3a69c7c.svg";
export { ForwardRef as ReactComponent };